// Human-readable booking duration. Durations of 60 minutes or more that are a whole or half
// hour read in hours ("1 hour", "1.5 hours", "3 hours"); anything under an hour (or not a
// clean half-hour) reads in minutes ("20 minutes", "45 minutes").
export function formatDuration(minutes: number): string {
  const isWholeOrHalfHour = minutes >= 60 && minutes % 30 === 0;
  if (!isWholeOrHalfHour) {
    return `${minutes} minutes`;
  }
  const hours = minutes / 60;
  // 1 -> "1 hour"; 1.5 -> "1.5 hours"; 3 -> "3 hours"
  const value = Number.isInteger(hours) ? String(hours) : hours.toFixed(1);
  return `${value} ${hours === 1 ? "hour" : "hours"}`;
}
